import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Badge,
} from '@travellegacy/nexops-design-system';
import { Tags } from 'lucide-react';
import type { TypeMetric } from '../api/demands.api';
import { formatDurationRich } from '../utils/format-duration';

interface Props {
  metrics: TypeMetric[];
  isLoading: boolean;
}

/**
 * Card com tempo médio/total por tipo de demanda no período selecionado.
 * Ordenado do tipo mais lento (maior média) para o mais rápido — o cabeçalho
 * ajuda a liderança a ver rapidamente onde estão os gargalos de categoria.
 */
export function MetricsByTypeCard({ metrics, isLoading }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Tags className="h-5 w-5" />
          Tempo médio por tipo de demanda
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-sm text-muted-foreground">Carregando…</p>
        ) : metrics.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Sem ciclos fechados no período selecionado.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tipo</TableHead>
                <TableHead className="text-right">Ciclos</TableHead>
                <TableHead className="text-right">Tempo total</TableHead>
                <TableHead className="text-right">Média por ciclo</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {metrics.map((m) => (
                <TableRow key={m.type}>
                  <TableCell className="font-medium">
                    <Badge variant="info" className="font-normal">
                      {m.type}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right tabular-nums">{m.cyclesCount}</TableCell>
                  <TableCell className="text-right tabular-nums">
                    {formatDurationRich(m.totalDurationMs)}
                  </TableCell>
                  <TableCell className="text-right tabular-nums font-mono">
                    {formatDurationRich(m.averageDurationMs)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
